export function isDebug(): boolean {
  return process.env.NEXT_PUBLIC_DEBUG === "true";
}

export function debugLog(scope: string, message: string, data?: unknown): void {
  if (!isDebug()) return;
  if (data !== undefined) {
    console.log(`[nice:${scope}]`, message, data);
  } else {
    console.log(`[nice:${scope}]`, message);
  }
}

export function debugWarn(scope: string, message: string, data?: unknown): void {
  if (!isDebug()) return;
  if (data !== undefined) {
    console.warn(`[nice:${scope}]`, message, data);
  } else {
    console.warn(`[nice:${scope}]`, message);
  }
}

export function debugError(scope: string, message: string, error?: unknown): void {
  if (!isDebug()) return;
  console.error(`[nice:${scope}]`, message, error);
}
